<template>
  <div class="rule-modal" v-show="show">
    <div class="bg-cover" :class="{'show': isShow}" @click="close"></div>
    <div class="rule-content" :class="{'show': isShow}" :style="{
      'background-color': bg_color,
      'color': tx_color,
      'padding-bottom': isShow ? isFullScreen ? '37px' : '21px' : '0px'
    }">
      <div class="title" v-if="title">{{ title }}</div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="bottom-btn" v-if="btn_text" @click="close">
        <p class="btn-text" :style="{color: btn_text_color, background: btn_bg_color}">{{ btn_text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '_lib/utils'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    bg_color: {
      type: String,
      default: '#fff',
    },
    tx_color: {
      type: String,
      default: '#000',
    },
    btn_text: {
      type: String,
      default: ''
    },
    btn_bg_color: {
      type: String,
      default: '#14191E'
    },
    btn_text_color: {
      type: String,
      default: '#FFF'
    }
  },
  data() {
    return {
      isShow: false,
      isFullScreen: false
    }
  },
  mounted() {
    this.isFullScreen = utils.isFullScreen()
  },
  watch: {
    'show': {
      handler: function (v) {
        if (v) {
          document.documentElement.style.overflow = 'hidden'
          setTimeout(() => { this.isShow = v }, 50)
        } else {
          document.documentElement.style.overflow = 'unset'
          this.isShow = false
          setTimeout(() => { this.$emit('update:show', false) }, 250)
        }
      },
    }
  },
  computed: {

  },
  filters: {

  },
  methods: {
    close() {
      this.isShow = false
      setTimeout(() => { this.$emit('update:show', false) }, 250)
    }
  }
}
</script>

<style scoped lang='less'>
.rule-modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;

  .bg-cover {
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.5);
    transition: all .25s;
    opacity: 0;

    &.show {
      opacity: 1;
    }
  }

  .rule-content {
    max-height: 0px;
    padding: 0 12px;
    transition: all .25s;
    position: fixed;
    bottom: 0;
    border-radius: 8px 8px 0px 0px;
    width: 100%;
    max-width: 480px;
    left: 50%;
    transform: translateX(-50%);
    &.show {
      max-height: calc(60vh);
      padding: 25px 12px 21px;
    }
    .title {
      font-family: PingFang SC;
      margin-bottom: 8px;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
    }
    .content {
      font-weight: 400;
      font-size: 13px;
      line-height: 19px;
      max-height: calc(60vh - 158px);
      overflow-y: auto;
    }
    .bottom-btn {
      margin-top: 10px;
      .btn-text {
        width: 100%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        color: #FFF;
        border-radius: 5px;
        background: #FF9341;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}
</style>